import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { EyeIcon, VolumeXIcon, HeartPulseIcon, MoonIcon, SmileIcon, WindIcon, CalendarDaysIcon } from 'lucide-react';
export function SalesLetterPineal() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const methods = [{
    icon: VolumeXIcon,
    text: 'Silencio, presencia y micro-hábitos'
  }, {
    icon: MoonIcon,
    text: 'Higiene del sueño'
  }, {
    icon: HeartPulseIcon,
    text: 'Regulación emocional'
  }, {
    icon: WindIcon,
    text: 'Meditación de claridad intuitiva (12 minutos)'
  }, {
    icon: CalendarDaysIcon,
    text: 'Método de 7 días (10–15 min/día) para que tu intuición deje de ser "confusión"'
  }];
  return <section ref={ref} className="w-full bg-gradient-to-b from-[#2d1b69] via-[#1a1a4e] to-[#0a0e27] py-20 px-4 md:py-28" data-id="element-198">
      <div className="max-w-4xl mx-auto" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-200">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#d4a853]/20 mb-6" data-id="element-201">
            <EyeIcon className="w-8 h-8 text-[#d4a853]" data-id="element-202" />
          </div>
          <p className="font-dm-sans text-sm text-[#d4a853] uppercase tracking-widest mb-2" data-id="element-203">
            Capítulo Especial
          </p>
          <h2 className="font-playfair text-2xl md:text-3xl lg:text-4xl text-[#f5f0e8]" data-id="element-204">
            Intuición y glándula pineal
          </h2>
          <p className="font-dm-sans text-lg text-[#f5f0e8]/60 mt-2" data-id="element-205">
            (sin exageraciones, con práctica)
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-dm-sans text-lg text-[#f5f0e8]/80 text-center mb-10" data-id="element-206">
          Aquí no vas a encontrar promesas raras. Vas a encontrar{' '}
          <span className="text-[#d4a853]" data-id="element-207">
            una forma realista de entrenar tu "antena interna"
          </span>{' '}
          con:
        </motion.p>

        <div className="space-y-4 mb-12" data-id="element-208">
          {methods.map((method, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.3 + index * 0.1
        }} className="flex items-center gap-4 bg-[#0a0e27]/40 rounded-lg p-4" data-id="element-209">
              <div className="w-10 h-10 rounded-full bg-[#d4a853]/10 flex items-center justify-center flex-shrink-0" data-id="element-210">
                <method.icon className="w-5 h-5 text-[#d4a853]" data-id="element-211" />
              </div>
              <p className="font-dm-sans text-[#f5f0e8]/90" data-id="element-212">{method.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="relative" data-id="element-213">
          {/* Decorative glow */}
          <div className="absolute inset-0 bg-[#d4a853] rounded-xl opacity-5 blur-xl" data-id="element-214" />

          <div className="relative bg-gradient-to-r from-[#d4a853]/10 via-[#d4a853]/20 to-[#d4a853]/10 border border-[#d4a853]/30 rounded-xl p-8 text-center" data-id="element-215">
            <SmileIcon className="w-10 h-10 text-[#d4a853] mx-auto mb-4" data-id="element-216" />
            <p className="font-playfair text-xl md:text-2xl text-[#f5f0e8] italic leading-relaxed" data-id="element-217">
              "Tu intuición no es miedo. No es ansiedad. No es impulso.
              <br data-id="element-218" />
              <span className="text-[#f0c75e]" data-id="element-219">
                Es claridad tranquila… cuando el ruido baja.
              </span>
              "
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}